module.exports = __webpack_public_path__ + "img/calculator-icon.2cbab0be.svg";